export const PROJECTS_NAVIGATION_ITEM = 'projectsNavigationMenuItem';
export const PROJECT_SETTINGS_NAVIGATION_ITEM = 'projectSettingsNavigationMenuItem';
export const MORE_PROJECTS_SEARCH = 'moreProjectsSearch';

export type ActionSubjectId = typeof PROJECTS_NAVIGATION_ITEM;
